const TEST_VARIATION_A = 'test_variation_a';
const TEST_VARIATION_B = 'test_variation_b';
const TEST_VARIATION_C = 'test_variation_c';

const EXPERIMENTS = {
    MUSTANGS_MP_NAV_BAR_JOB_POST_EP: 4991
};

const getTestVariation = (abTests = {}, testNumber) => {
    const variation = abTests[testNumber];

    if (typeof variation === 'undefined' || variation === '0' || Number(variation) === 1) {
        return TEST_VARIATION_A;
    } else if (Number(variation) === 2) {
        return TEST_VARIATION_B;
    } else {
        return TEST_VARIATION_C;
    }
};

const inAbTest = (abTests, testNumber) => {
    const variation = getTestVariation(abTests, testNumber);

    return variation !== TEST_VARIATION_A;
};

module.exports = {
    TEST_VARIATION_A,
    TEST_VARIATION_B,
    TEST_VARIATION_C,
    getTestVariation,
    inAbTest,
    EXPERIMENTS
};
